/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Section_SellersInputs */

const en_footer_section_sellers = /** @type {(inputs: Footer_Section_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For Sellers`)
};

const es_footer_section_sellers = /** @type {(inputs: Footer_Section_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para vendedores`)
};

const fr_footer_section_sellers = /** @type {(inputs: Footer_Section_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour les vendeurs`)
};

const de_footer_section_sellers = /** @type {(inputs: Footer_Section_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Verkäufer`)
};

const ja_footer_section_sellers = /** @type {(inputs: Footer_Section_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出品者向け`)
};

const zh_footer_section_sellers = /** @type {(inputs: Footer_Section_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`卖家中心`)
};

const ar_footer_section_sellers = /** @type {(inputs: Footer_Section_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`للبائعين`)
};

const id_footer_section_sellers = /** @type {(inputs: Footer_Section_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk Penjual`)
};

const it_footer_section_sellers = /** @type {(inputs: Footer_Section_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per i Venditori`)
};

const ru_footer_section_sellers = /** @type {(inputs: Footer_Section_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для продавцов`)
};

const pt_footer_section_sellers = /** @type {(inputs: Footer_Section_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para Vendedores`)
};

const ko_footer_section_sellers = /** @type {(inputs: Footer_Section_SellersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`판매자용`)
};

/**
* | output |
* | --- |
* | "For Sellers" |
*
* @param {Footer_Section_SellersInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const footer_section_sellers = /** @type {((inputs?: Footer_Section_SellersInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Section_SellersInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_section_sellers(inputs)
	if (locale === "es") return es_footer_section_sellers(inputs)
	if (locale === "fr") return fr_footer_section_sellers(inputs)
	if (locale === "de") return de_footer_section_sellers(inputs)
	if (locale === "ja") return ja_footer_section_sellers(inputs)
	if (locale === "zh") return zh_footer_section_sellers(inputs)
	if (locale === "ar") return ar_footer_section_sellers(inputs)
	if (locale === "id") return id_footer_section_sellers(inputs)
	if (locale === "it") return it_footer_section_sellers(inputs)
	if (locale === "ru") return ru_footer_section_sellers(inputs)
	if (locale === "pt") return pt_footer_section_sellers(inputs)
	return ko_footer_section_sellers(inputs)
});